import {
  SETTLEMENT_REPORT_FILE_SUCCESS,
  SETTLEMENT_REPORT_FILE_FAILED,
  RESET_SETTLEMENT_REPORT_FILE,
  LOADING_SETTLEMENT_REPORT_FILE,
  NETWORK_ERROR_SETTLEMENT_REPORT_FILE,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SETTLEMENT_REPORT_FILE: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case SETTLEMENT_REPORT_FILE_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case SETTLEMENT_REPORT_FILE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_SETTLEMENT_REPORT_FILE: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: true,
        networkError: true,
        data: {},
      };
    }
    case RESET_SETTLEMENT_REPORT_FILE: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
